type Props = {
  id?: string;
  className?: string;
  children?: React.ReactNode;
};

function MenuItemAddon({ id, className, children }: Props) {
  return (
    <div id={id} className={className}>
      {children}
    </div>
  );
}

export default MenuItemAddon;
